import React from "react";
import { Drawer } from "@mui/material";

const DEFAULT_WIDTH = 440;
const TRANSITION = "width 0.25s ease, opacity 0.2s ease";

/**
 * Reusable collapsible side-drawer shell.
 * Renders `children` inside a permanent MUI Drawer with a smooth open/close transition.
 * Toggle is handled externally (e.g. a button in the navbar).
 *
 * @param {boolean}  open      Whether the drawer is visible.
 * @param {number}   width     Drawer width in px (default 440).
 * @param {string}   anchor    "left" or "right" (default "left").
 * @param {React.Node} children Content rendered inside the drawer body.
 */
export default function TreeViewDrawer({
  open,
  width = DEFAULT_WIDTH,
  anchor = "left",
  children,
}) {
  return (
    <Drawer
      variant="permanent"
      anchor={anchor}
      sx={{
        width: open ? width : 0,
        height: "100%",
        flexShrink: 0,
        display: { xs: "none", sm: "block" },
        transition: TRANSITION,
        overflow: "hidden",
        "& .MuiDrawer-paper": {
          position: "relative",
          width,
          height: "100%",
          boxSizing: "border-box",
          transition: TRANSITION,
          opacity: open ? 1 : 0,
        },
      }}
    >
      {children}
    </Drawer>
  );
}
